import React, { useEffect, useState } from 'react';
import { db } from '../../firebase'; 
import { collection, query, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  FaCheckCircle,
  FaEnvelope, 
  FaSignOutAlt,
  FaSpinner,
  FaExclamationTriangle
} from 'react-icons/fa';
import Satisfaction from './Satisfaction';
import './Confirmation.css';
import Footer from '../Footer';

const Confirmation = () => {
  const [commande, setCommande] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSatisfaction, setShowSatisfaction] = useState(false);
  const location = useLocation();
  const { paymentIntent } = location.state || {}; 
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const [tableLabel, setTableLabel] = useState('');
  const navigate = useNavigate();
  const { articles: stateArticles, total: stateTotal } = location.state || {};
  const [articles] = useState(stateArticles || JSON.parse(localStorage.getItem('articles')) || []);
  const [total] = useState(stateTotal || JSON.parse(localStorage.getItem('total')) || 0);
  const [popup, setPopup] = useState({ visible: false, message: '', type: 'success' });


    useEffect(() => {
      if (userInfo.table === 'a_emporter') {
        setTableLabel('À Emporter');
      } else {
        setTableLabel(`Numéro de Table : ${userInfo.table}`);
      }
    }, [userInfo.table]);  

  useEffect(() => {
    if (showSatisfaction) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Cleanup function
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showSatisfaction]);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  
    if (!userInfo || !userInfo.id) {
      setError("Utilisateur non trouvé.");
      return;
    }
  
    const fetchCommande = async () => {
      try {
        const commandesRef = collection(db, `clients/${userInfo.id}/commande`);
        const q = query(commandesRef);
  
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            setCommande(doc.data());
          });
        } else {
          setError("Commande non trouvée.");
        }
      } catch (err) {
        setError("Erreur lors de la récupération de la commande.");
        console.error("Erreur:", err);
      }
    };
  
    fetchCommande();
  
    const timer = setTimeout(() => {
      setShowSatisfaction(true);
    }, 3000);
  
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (showSatisfaction) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [showSatisfaction]);

    const handleSendInvoice = async () => {
      setLoading(true); // Indique qu'un envoi est en cours
      try {
        // Appel à l'API pour envoyer la facture
        const response = await fetch('https://skaneat-app.vercel.app/send-invoice', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: userInfo.email, // Adresse e-mail du client
            prenom: userInfo.prenom, // Prénom du client
            table: userInfo.table, // Table ou à emporter
            id_client: userInfo.idclient, // ID client
            items: articles, // Liste complète des articles de la commande
            totalCommande: total, // Total global de la commande
          }),
        });
    
        console.log('Données envoyées :', {
          email: userInfo.email,
          prenom: userInfo.prenom,
          table: userInfo.table,
          id_client: userInfo.idclient,
          items: articles,
          totalCommande: total,
        });
    
        const data = await response.json();
        if (response.ok) {
          setPopup({ visible: true, message: "Votre facture a été envoyée avec succès à votre adresse email.", type: 'success' });
        } else {
          console.error('Erreur serveur :', data.error);
          setPopup({ visible: true, message: "Une erreur est survenue lors de l'envoi de la facture. Veuillez réessayer.", type: 'error' });
        }
      } catch (err) {
        console.error("Erreur lors de l'envoi de la facture :", err);
        setPopup({ visible: true, message: "Une erreur est survenue lors de l'envoi de la facture. Veuillez réessayer.", type: 'error' });
      }
      setLoading(false);
    };    

    const handleFinishOrder = async () => {
      setTimeout(async () => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo) {
          try {
            const clientRef = doc(db, `clients/${userInfo.id}`);
            
            // Supprimer toutes les collections associées au client
            const collectionsToDelete = ['commande']; // Liste des sous-collections
          
            for (const collectionName of collectionsToDelete) {
              const collectionRef = collection(db, `clients/${userInfo.id}/${collectionName}`);
              const snapshot = await getDocs(collectionRef);
              
              const deletePromises = snapshot.docs.map((doc) => deleteDoc(doc.ref));
              await Promise.all(deletePromises);
            }
    
            // Supprimer le document principal du client après avoir supprimé ses sous-collections
            await deleteDoc(clientRef);
            console.log('Client et toutes ses sous-collections supprimés.');
          } catch (error) {
            console.error('Erreur lors de la suppression complète du client:', error);
          }
        }
    
        // Nettoyage du localStorage et redirection
        localStorage.removeItem('userInfo');
        localStorage.removeItem('commande');
        localStorage.removeItem('articles');
        localStorage.removeItem('cart');
        localStorage.removeItem('total');
        navigate('/?success=order_completed');
      }, 500);
    };    

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <div className="confirmation-page">
      {paymentIntent && paymentIntent.status === 'succeeded' ? (
        <>
          {/* Success Header */}
          <div className="success-header">
            <FaCheckCircle className="success-icon" />
            <h1>Paiement réussi !</h1>
            <p>Votre commande a été confirmée</p>
          </div>

          {/* Order Summary */}
          <div className="order-summary">
            <h2>Résumé de votre commande</h2>
            
            {commande ? (
              <>
                {/* Order Info */}
                <div className="order-info">
                  <div className="info-item">
                    <span className="info-label">Client</span>
                    <span className="info-value">{userInfo.prenom}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Table</span>
                    <span className="info-value">{tableLabel}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Commande</span>
                    <span className="info-value">#{userInfo.idclient}</span>
                  </div>
                </div>

                {/* Items */}
                <div className="items-section">
                  <h3>Articles commandés</h3>
                  <div className="items-list">
                    {articles.map((item, index) => (
                      <div key={index} className="confirmation-item">
                        <div className="confirmation-item-header">
                          <span className="confirmation-item-name">{item.nom}</span>
                          <span className="confirmation-item-quantity">x{item.quantity}</span>
                        </div>
                        <div className="confirmation-item-prices">
                          <span className="confirmation-unit-price">{item.prix.toFixed(2)}€</span>
                          <span className="confirmation-total-price">{(item.prix * item.quantity).toFixed(2)}€</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Total */}
                <div className="total-section">
                  <div className="total">
                    <span className="total-label">Total général</span>
                    <span className="total-amount">{total.toFixed(2)} €</span>
                  </div>
                </div>

                {/* Actions */}
                <div className="actions">
                  <button className="send-btn" onClick={handleSendInvoice} disabled={loading}>
                    {loading ? (
                      <>
                        <FaSpinner className="spinning" />
                        Envoi en cours...
                      </>
                    ) : (
                      <>
                        <FaEnvelope />
                        Envoyer la facture par e-mail
                      </>
                    )}
                  </button>
                  
                  <button className="quit-btn" onClick={handleFinishOrder}>
                    <FaSignOutAlt />
                    Quitter
                  </button>
                </div>
              </>
            ) : (
              <div className="loading">
                <FaSpinner className="spinning" />
                <p>Chargement de votre commande...</p>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="error">
          <h1>Une erreur est survenue</h1>
          <p>Veuillez réessayer ou contacter le support.</p>
        </div>
      )}

      {/* Satisfaction Popup */}
      {showSatisfaction && (
        <>
          <div className="satisfaction-overlay" />
          <div className="satisfaction-popup">
            <div className="satisfaction-popup-content">
              <Satisfaction setShowSatisfaction={setShowSatisfaction} />
            </div>
          </div>
        </>
      )}

      {/* Email Popup */}
      {popup.visible && (
        <>
          <div className="email-popup-overlay" />
          <div className="email-popup">
            <div className="email-popup-content">
              <div className="popup-icon">
                {popup.type === 'success' ? (
                  <FaCheckCircle className="success-icon" />
                ) : (
                  <FaExclamationTriangle className="error-icon" />
                )}
              </div>
              <h3 className="popup-title">
                {popup.type === 'success' ? 'Facture envoyée !' : 'Erreur d\'envoi'}
              </h3>
              <p className="popup-message">{popup.message}</p>
              <button 
                className="popup-close-btn"
                onClick={() => setPopup({ ...popup, visible: false })}
              >
                Fermer
              </button>
            </div>
          </div>
        </>
      )}
      
      <Footer />
    </div>
  );
};

export default Confirmation;
